export const GET_ALL_FEEDBACKS = 'GET_ALL_FEEDBACKS'
export const CREATE_FEEDBACK = 'CREATE_FEEDBACK'
export const GET_WORD_CHART = 'GET_WORD_CHART'
export const GET_NPS_SCORE = 'GET_NPS_SCORE'

export const GET_FEEDBACK_QUESTIONS = 'GET_FEEDBACK_QUESTIONS'
